export const SET_DEVICE = 'SET_DEVICE';
export const SET_VERSION = 'SET_VERSION';
export const SET_REDIRECT_PATH = 'SET_REDIRECT_PATH';
export const HIDE_BACK_BUTTON = 'HIDE_BACK_BUTTON';


// WEBPACK FOOTER //
// ./src/redux_related/ui/actions.js